import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Link 
} from '@mui/material';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        backgroundColor: 'grey.100',
        py: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 2
        }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} checkboxr. Location-aware todo application.
          </Typography>
          
          {/* TODO: Restore when proper legal pages are implemented */}
          {/* <Box sx={{ display: 'flex', gap: 2 }}>
            <Link 
              href="https://github.com" 
              color="text.secondary" 
              variant="body2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy
            </Link>
            <Link 
              href="https://github.com" 
              color="text.secondary" 
              variant="body2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms
            </Link>
            <Link 
              href="https://github.com" 
              color="text.secondary" 
              variant="body2"
              target="_blank"
              rel="noopener noreferrer"
            >
              Support
            </Link>
          </Box> */}
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;